// extracted by mini-css-extract-plugin
export default {"assignServiceModalWrap":"AssignServiceModal_assignServiceModalWrap__OIP1A","flex-end":"AssignServiceModal_flex-end__INswI"};